import React from 'react';
import {Router, Route, browserHistory} from 'react-router'

import authRedirect from './HigherOrder/Auth';
import BodyClassName from './HigherOrder/BodyClassName';
import BlankPage from './HigherOrder/BlankPage';

import HomePage from './Pages/Home';
import MeditationsPage from './Pages/Meditations';
import ProfilePage from './Pages/Profile';
import StatisticsPage from './Pages/Statistics';
import PlayScreen from './Pages/PlayScreen';
import LoginPage from './Pages/Login';
import RegisterPage from './Pages/Register';
import ForgottenPassword from './Pages/ForgottenPassword';
import ResetPassword from './Pages/ResetPassword';

import ContactsPage from './Pages/Contacts';
import FaqPage from './Pages/Faq';
import TeamPage from './Pages/Team';
import AboutMeditationPage from './Pages/AboutMeditation';
import PrivacyPolicyPage from './Pages/PrivacyPolicy';
import TermsPage from './Pages/Terms';
import CookiesPage from './Pages/Cookies';

import NotFoundPage from './Pages/NotFoundPage';

import ConfirmEmailPage from './Pages/ConfirmEmail';

import RegisterBetaPage from './Pages/BetaRegister';

import {connect} from 'react-redux';
import {closePushMenu} from '../actions/PushMenu';
import {pageView} from '../actions/Util';

import ReactGA from 'react-ga';
import config from '../config';

class App extends React.Component {
    constructor(props) {
        super(props);

        this.changeRoute = this.changeRoute.bind(this);

        ReactGA.initialize(config.GA.id);
    }

    changeRoute() {
        window.scrollTo(0, 0);
        this.props.dispatch(pageView());
        this.props.dispatch(closePushMenu());
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render() {
        return (
            <Router history={browserHistory}>
                <Route component={BlankPage}>

                    <Route path="/"
                        component={BodyClassName(HomePage, 'not-logged-in', true)}
                        onEnter={this.changeRoute}/>
                    <Route path="/meditations" component={MeditationsPage} onEnter={this.changeRoute}/>
                    <Route path="/profile" component={authRedirect(ProfilePage, true, '/login')}
                           onEnter={this.changeRoute}/>
                    <Route path="/statistics" component={authRedirect(StatisticsPage, true, '/')}
                           onEnter={this.changeRoute}/>
                    <Route path="/meditate/:id" component={authRedirect(PlayScreen, true, '/login')}
                           onEnter={this.changeRoute}/>

                    <Route path="/about-meditation" component={AboutMeditationPage} onEnter={this.changeRoute}/>
                    <Route path="/team" component={TeamPage} onEnter={this.changeRoute}/>
                    <Route path="/faq" component={FaqPage} onEnter={this.changeRoute}/>
                    <Route path="/contacts" component={ContactsPage} onEnter={this.changeRoute}/>
                    <Route path="/privacy-policy" component={PrivacyPolicyPage} onEnter={this.changeRoute}/>
                    <Route path="/terms-and-conditions" component={TermsPage} onEnter={this.changeRoute}/>
                    <Route path="/cookies" component={CookiesPage} onEnter={this.changeRoute}/>

                    <Route path="/login" component={authRedirect(LoginPage, false, '/')}
                           onEnter={this.changeRoute}/>
                    <Route path="/register" component={authRedirect(RegisterPage, false, '/')}
                           onEnter={this.changeRoute}/>
                    <Route path="/forgotten-password" component={authRedirect(ForgottenPassword, false, '/')}
                           onEnter={this.changeRoute}/>
                    <Route path="/reset-password/:token" component={authRedirect(ResetPassword, false, '/')}
                           onEnter={this.changeRoute}/>

                    <Route path='confirm-email/:token' component={ConfirmEmailPage} onEnter={this.changeRoute}/>

                    <Route path='*' exact={true} component={BodyClassName(NotFoundPage, 'not-found')}
                           onEnter={this.changeRoute}/>
                </Route>
            </Router>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(null, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/components/App.js